// @ts-strict-ignore
import {Component, Input, OnChanges, OnInit, output, SimpleChanges} from "@angular/core";
import {CameraLayout, TrainingRoom} from "@models";
import {Translations} from "@translations";
import {TranslateService} from "@ngx-translate/core";
import {SimConfigurationService} from "@services";

@Component({
	selector: "sim-room-layout-switcher",
	templateUrl: "./room-layout-switcher.component.html",
	styleUrls: ["./room-layout-switcher.component.scss"],
	standalone: false,
})
export class RoomLayoutSwitcherComponent implements OnInit, OnChanges {
	settings = SimConfigurationService.settings;
	T = Translations;

	RoomLayoutSwitcherComponent = RoomLayoutSwitcherComponent;
	public static readonly maxAmountLayouts: number = 4;

	@Input() styling: "default" | "room-detail" | "live-view" = "default";
	@Input() trainingRoom: TrainingRoom;
	@Input() loadingRoomChange: boolean = false;
	@Input() disabled: boolean;
	@Input() selectedPreset: number;
	nextPreset: number;

	selectedPresetChange = output<number>();

	constructor(private translate: TranslateService) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (!this.loadingRoomChange) {
			this.nextPreset = this.selectedPreset;
		}
	}

	ngOnInit(): void {
		this.nextPreset = this.selectedPreset;
	}

	setSelectedPreset(preset: number) {
		if (!!this.trainingRoom?.roomLayout?.[preset]) {
			this.nextPreset = preset;
			this.selectedPresetChange.emit(preset);
		}
	}

	public getPresetName(cameraLayoutPresets: CameraLayout[], i: number, forHint: boolean = false): string {
		const hintKey = this.T.SHARED_RECORDER_SWITCH_LAYOUT;
		let name: string = null;
		let isFallback = false;

		if (this.settings.enableRoomLayoutNaming) {
			name = cameraLayoutPresets?.[i]?.roomLayoutName;
		}
		if (!name) {
			name = (i + 1).toString();
			isFallback = true;
		}

		if (forHint && isFallback) {
			return this.translate.instant(hintKey, {number: name});
		} else {
			return name;
		}
	}
}
